import React from "react";

export const HomeIcon = ({ size = 24, ...props }) => (
  <svg width={size} height={size} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g clipPath="url(#clip0_home)">
      <path d="M6.66667 16H4L16 4L28 16H25.3333" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M6.66406 16V25.3333C6.66406 26.0406 6.94501 26.7189 7.44511 27.219C7.94521 27.719 8.62349 28 9.33073 28H22.6641C23.3713 28 24.0496 27.719 24.5497 27.219C25.0498 26.7189 25.3307 26.0406 25.3307 25.3333V16" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M12 28.0002V20.0002C12 19.2929 12.281 18.6146 12.781 18.1145C13.2811 17.6144 13.9594 17.3335 14.6667 17.3335H17.3333C18.0406 17.3335 18.7189 17.6144 19.219 18.1145C19.719 18.6146 20 19.2929 20 20.0002V28.0002" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round"/>
    </g>
    <defs>
      <clipPath id="clip0_home">
        <rect width="32" height="32" fill="white"/>
      </clipPath>
    </defs>
  </svg>
);

export const UserIcon = ({ size = 24, ...props }) => (
  <svg width={size} height={size} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g clipPath="url(#clip0_user)">
      <path d="M10.6641 9.33333C10.6641 10.7478 11.226 12.1044 12.2262 13.1046C13.2264 14.1048 14.5829 14.6667 15.9974 14.6667C17.4119 14.6667 18.7684 14.1048 19.7686 13.1046C20.7688 12.1044 21.3307 10.7478 21.3307 9.33333C21.3307 7.91885 20.7688 6.56229 19.7686 5.5621C18.7684 4.5619 17.4119 4 15.9974 4C14.5829 4 13.2264 4.5619 12.2262 5.5621C11.226 6.56229 10.6641 7.91885 10.6641 9.33333Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M8 28V25.3333C8 23.9188 8.5619 22.5623 9.5621 21.5621C10.5623 20.5619 11.9188 20 13.3333 20H18.6667C20.0812 20 21.4377 20.5619 22.4379 21.5621C23.4381 22.5623 24 23.9188 24 25.3333V28" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    </g>
    <defs>
      <clipPath id="clip0_user">
        <rect width="32" height="32" fill="white"/>
      </clipPath>
    </defs>
  </svg>
);

export const UnitIcon = ({ size = 24, ...props }) => (
  <svg width={size} height={size} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g clipPath="url(#clip0_unit)">
      <path d="M4 28H28" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M12 10.6665H13.3333" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M12 16H13.3333" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M12 21.3335H13.3333" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M18.6641 10.6665H19.9974" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M18.6641 16H19.9974" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M18.6641 21.3335H19.9974" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M6.66406 28V6.66667C6.66406 5.95942 6.94501 5.28115 7.44511 4.78105C7.94521 4.28095 8.62349 4 9.33073 4H22.6641C23.3713 4 24.0496 4.28095 24.5497 4.78105C25.0498 5.28115 25.3307 5.95942 25.3307 6.66667V28" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    </g>
    <defs>
      <clipPath id="clip0_unit">
        <rect width="32" height="32" fill="white"/>
      </clipPath>
    </defs>
  </svg>
);

export const LocationIcon = ({ size = 24, ...props }) => (
  <svg width={size} height={size} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g clipPath="url(#clip0_location)">
      <path d="M12 14.6665C12 15.7274 12.4214 16.7448 13.1716 17.4949C13.9217 18.2451 14.9391 18.6665 16 18.6665C17.0609 18.6665 18.0783 18.2451 18.8284 17.4949C19.5786 16.7448 20 15.7274 20 14.6665C20 13.6056 19.5786 12.5882 18.8284 11.8381C18.0783 11.0879 17.0609 10.6665 16 10.6665C14.9391 10.6665 13.9217 11.0879 13.1716 11.8381C12.4214 12.5882 12 13.6056 12 14.6665Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M23.5453 22.2094L17.8879 27.8668C17.3879 28.3663 16.7101 28.6469 16.0033 28.6469C15.2965 28.6469 14.6186 28.3663 14.1186 27.8668L8.45994 22.2094C6.96824 20.7177 5.95239 18.817 5.54086 16.7479C5.12933 14.6788 5.3406 12.5341 6.14795 10.5851C6.9553 8.63603 8.32247 6.97015 10.0766 5.79811C11.8307 4.62606 13.893 4.00049 16.0026 4.00049C18.1123 4.00049 20.1745 4.62606 21.9286 5.79811C23.6827 6.97015 25.0499 8.63603 25.8573 10.5851C26.6646 12.5341 26.8759 14.6788 26.4644 16.7479C26.0528 18.817 25.037 20.7177 23.5453 22.2094Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    </g>
    <defs>
      <clipPath id="clip0_location">
        <rect width="32" height="32" fill="white"/>
      </clipPath>
    </defs>
  </svg>
);

export const AttendanceIcon = ({ size = 24, ...props }) => (
  <svg width={size} height={size} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g clipPath="url(#clip0_attendance)">
      <path d="M16.0026 27.9998H8.0026C7.29536 27.9998 6.61708 27.7189 6.11699 27.2188C5.61689 26.7187 5.33594 26.0404 5.33594 25.3332V9.33317C5.33594 8.62593 5.61689 7.94765 6.11699 7.44755C6.61708 6.94746 7.29536 6.6665 8.0026 6.6665H24.0026C24.7098 6.6665 25.3881 6.94746 25.8882 7.44755C26.3883 7.94765 26.6693 8.62593 26.6693 9.33317V15.3332" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M21.3359 4V9.33333" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M10.6641 4V9.33333" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M5.33594 14.6665H26.6693" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M22.6641 22.6667C22.6641 23.3739 22.945 24.0522 23.4451 24.5523C23.9452 25.0524 24.6235 25.3333 25.3307 25.3333C26.038 25.3333 26.7162 25.0524 27.2163 24.5523C27.7164 24.0522 27.9974 23.3739 27.9974 22.6667C27.9974 21.9594 27.7164 21.2811 27.2163 20.781C26.7162 20.281 26.038 20 25.3307 20C24.6235 20 23.9452 20.281 23.4451 20.781C22.945 21.2811 22.6641 21.9594 22.6641 22.6667Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M29.3359 29.3332C29.3359 28.6259 29.055 27.9477 28.5549 27.4476C28.0548 26.9475 27.3765 26.6665 26.6693 26.6665H24.0026C23.2954 26.6665 22.6171 26.9475 22.117 27.4476C21.6169 27.9477 21.3359 28.6259 21.3359 29.3332" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    </g>
    <defs>
      <clipPath id="clip0_attendance">
        <rect width="32" height="32" fill="white"/>
      </clipPath>
    </defs>
  </svg>
);

export const ReportIcon = ({ size = 24, ...props }) => (
  <svg width={size} height={size} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g clipPath="url(#clip0_report)">
      <path d="M18.6641 4V9.33333C18.6641 9.68695 18.8045 10.0261 19.0546 10.2761C19.3046 10.5262 19.6438 10.6667 19.9974 10.6667H25.3307" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M22.6641 28H9.33073C8.62349 28 7.94521 27.719 7.44511 27.219C6.94501 26.7189 6.66406 26.0406 6.66406 25.3333V6.66667C6.66406 5.95942 6.94501 5.28115 7.44511 4.78105C7.94521 4.28095 8.62349 4 9.33073 4H18.6641L25.3307 10.6667V25.3333C25.3307 26.0406 25.0498 26.7189 24.5497 27.219C24.0496 27.719 23.3713 28 22.6641 28Z" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M12 22.6667V16" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M16 22.6666V21.3333" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M20 22.6667V18.6667" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round"/>
    </g>
    <defs>
      <clipPath id="clip0_report">
        <rect width="32" height="32" fill="white"/>
      </clipPath>
    </defs>
  </svg>
);

export const BranchIcon = ({ size = 24, ...props }) => (
  <svg width={size} height={size} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g clipPath="url(#clip0_branch)">
      <path d="M4 28H28" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M5.33333 28V12L16 4L26.6667 12V28" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M13.3333 28V20C13.3333 19.116 14.5273 18.6667 16 18.6667C17.4727 18.6667 18.6667 19.116 18.6667 20V28" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M9.33334 16H10.6667" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M21.3333 16H22.6667" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    </g>
    <defs>
      <clipPath id="clip0_branch">
        <rect width="32" height="32" fill="white"/>
      </clipPath>
    </defs>
  </svg>
);

export const TaskIcon = ({ size = 24, ...props }) => (
  <svg width={size} height={size} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g clipPath="url(#clip0_task)">
      <path d="M12 2.6665H20C20.7364 2.6665 21.3333 3.26346 21.3333 3.99984V6.6665H10.6667V3.99984C10.6667 3.26346 11.2636 2.6665 12 2.6665Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M24 5.3335H25.3333C26.0697 5.3335 26.6667 5.93045 26.6667 6.66683V26.6668C26.6667 27.4032 26.0697 28.0002 25.3333 28.0002H6.66667C5.93029 28.0002 5.33333 27.4032 5.33333 26.6668V6.66683C5.33333 5.93045 5.93029 5.3335 6.66667 5.3335H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M10.6641 14.6665L13.3307 17.3332L21.3307 9.33317" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M10.6641 22.6667H21.3307" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    </g>
    <defs>
      <clipPath id="clip0_task">
        <rect width="32" height="32" fill="white"/>
      </clipPath>
    </defs>
  </svg>
);

export const TrainIcon = ({ size = 24, ...props }) => (
  <svg width={size} height={size} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <rect x="6" y="8" width="20" height="16" rx="3" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M10 24L7 28" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M22 24L25 28" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M6 16H26" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <circle cx="11" cy="20" r="1.5" fill="currentColor"/>
    <circle cx="21" cy="20" r="1.5" fill="currentColor"/>
  </svg>
);

export const ReceiptIcon = ({ size = 24, ...props }) => (
  <svg width={size} height={size} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M6 4H26V28L23 25L20 28L17 25L14 28L11 25L8 28L6 26V4Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M11 10H21" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M11 15H21" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M11 20H17" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

export const ClipboardIcon = ({ size = 24, ...props }) => (
  <svg width={size} height={size} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M12 4H20C20.7364 4 21.3333 4.59696 21.3333 5.33334V8H10.6667V5.33334C10.6667 4.59696 11.2636 4 12 4Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M24 6.6665H25.3333C26.0697 6.6665 26.6667 7.26346 26.6667 7.99984V28C26.6667 28.7364 26.0697 29.3333 25.3333 29.3333H6.66667C5.93029 29.3333 5.33333 28.7364 5.33333 28V7.99984C5.33333 7.26346 5.93029 6.6665 6.66667 6.6665H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M11 15L14 18L21 11" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

export const AnchorIcon = ({ size = 24, ...props }) => (
  <svg width={size} height={size} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M16 8V24" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <circle cx="16" cy="6" r="3" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M6 16C6 21.5228 10.4772 26 16 26C21.5228 26 26 21.5228 26 16" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M4 16H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M24 16H28" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

export const PackageIcon = ({ size = 24, ...props }) => (
  <svg width={size} height={size} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M16 4L26 9V23L16 28L6 23V9L16 4Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M16 4V16" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M6 9L16 14L26 9" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M11 18.5L16 21L21 18.5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

export const TruckIcon = ({ size = 24, ...props }) => (
  <svg width={size} height={size} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M4 22H24M24 22H28V15H21V10H4V22ZM14 22H24" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M21 15H28L25 10H21V15Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <circle cx="8" cy="22" r="3" stroke="currentColor" strokeWidth="2"/>
    <circle cx="20" cy="22" r="3" stroke="currentColor" strokeWidth="2"/>
  </svg>
);
